import { render } from "./BusinessPayment.vue?vue&type=template&id=1befcc6a"
import script from "./BusinessPayment.vue?vue&type=script&lang=js"
export * from "./BusinessPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__